import Users from '../components/Users';

const UsersScreen = () => <Users />;

export default UsersScreen;
